import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useLocation } from "react-router-dom";
import { addEspaceCharacters, deleteTableDots, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { AlertDialog } from "../Components/AlertDialog";
import SettingsTwoToneIcon from "@mui/icons-material/SettingsTwoTone";
import SaveTwoToneIcon from "@mui/icons-material/SaveTwoTone";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";
import { useAuth } from "../Components/AuthContext";
import { LoaderBox } from "../Components/LoaderBox";

function RolEditar() {
  const { state } = useLocation();
  const { id, nombre } = state;
  const [nombreActual, setNombreActual] = useState(nombre);
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [dialog, setDialog] = React.useState({
    title: "",
    text: "",
  });
  const [openAlertDialog, setOpenAlertDialog] = React.useState(false);
  const [alertDialog, setAlertDialog] = React.useState({
    title: "Alerta",
    text: `¿Deseas eliminar el rol de "${nombreActual}"?`,
  });
  const [editName, setEditName] = useState(false);
  const [nombreNuevo, setNombreNuevo] = useState(nombre);
  deleteTableDots(1);
  const { user } = useAuth();
  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      size: 150,
      accessorKey: "nombre",
      header: "Nombre",
    },
    {
      accessorKey: "estado",
    },
    {
      accessorFn: (row) => `${row.id}${row.nombre}`,
      id: "edit",
      header: "",
      enableColumnFilter: false,
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button onClick={() => console.log("")}>
            <Switch
              color="success"
              checked={row.original.estado === 1}
              onChange={() => ToggleFunctionXRol(row.original.id)}
            />
          </Button>
        </Box>
      ),
    },
  ]);

  const ToggleFunctionXRol = (funcion) => {
    instance
      .patch(`/rol/toggleFuncionXRol`, {
        rol: id,
        funcion: funcion,
      })
      .then((res) => {
        populateTable();
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  };

  async function populateTable() {
    try {
      const { data } = await instance.get("/rol/funciones/" + id);
      setItems(data);
    } catch (error) {
      alert(error);
    }
  }
  if (isLoading) {
    populateTable();
    setLoading(false);
  }
  function handleDeactivate() {
    instance
      .delete(`/rol/eliminar/${id}`)
      .then((res) => {
        setDialog({
          title: "Operación exitosa",
          text: `El rol ha ${nombreActual}, sido eliminado exitosamente.`,
          redirect: true,
          page: "/Roles",
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  }

  const yesClick = () => {
    handleDeactivate();
    setOpenAlertDialog(false);
  };
  const noClick = () => {
    setOpenAlertDialog(false);
  };

  const handleNameChange = () => {
    let form = {
      id: id,
      nombre: addEspaceCharacters(nombreNuevo),
      user: user.id,
    };
    instance
      .patch("rol/", form)
      .then((res) => {
        setDialog({
          title: "Actualización exitosa",
          text: `Se han actualizado los datos del rol de forma exitosa.`,
        });
        setNombreActual(nombreNuevo);
        setEditName(false);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          rowGap: 4,
          marginTop: 4,
        }}
      >
        <Typography
          component="h1"
          variant="h5"
          sx={{ display: editName ? "none" : "block" }}
        >
          Rol: {nombreActual}
          <Tooltip title="Modificar">
            <IconButton onClick={() => setEditName(true)}>
              <SettingsTwoToneIcon />
            </IconButton>
          </Tooltip>
        </Typography>
        <Grid
          container
          sx={{
            display: editName ? "flex" : "none",
            xs: { flexDirection: "column" },
            md: { flexDirection: "row" },
          }}
          md={4}
        >
          <Grid item xs={12} md={8}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="nombre"
              label="Nombre"
              name="nombre"
              value={nombreNuevo}
              autoFocus
              onChange={(e) => setNombreNuevo(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{ display: "flex", flexDirection: "row" }}
          >
            <Grid
              item
              xs={12}
              md={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Tooltip title="Guardar">
                <IconButton onClick={() => handleNameChange()} color="success">
                  <SaveTwoToneIcon />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Tooltip title="Cancelar">
                <IconButton onClick={() => setEditName(false)} color="error">
                  <CancelTwoToneIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
        <Grid container xs={12} sm={6}>
          <Grid item xs={12}>
            <MaterialReactTable
              localization={MRT_Localization_ES}
              columns={columns}
              data={items}
              initialState={{
                //showColumnFilters: false,
                density: "compact",
                columnVisibility: { id: false, estado: false },
                pagination: { pageSize: 5 },
              }}
              enableColumnFilterModes={false}
              //enableColumnOrdering={false}
              enableGrouping={false}
              enablePinning={false}
              enableRowActions={false}
              positionToolbarAlertBanner="none"
              enableColumnFilters={false}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              enableHiding={false}
              enablePagination={true}
              enableTopToolbar={true}
              enableBottomToolbar={true}
            />
          </Grid>
          <Grid item sx={{ display: "flex", justifyContent: "center" }} xs={12}>
            <Button
              color="error"
              sx={{ marginTop: 2, marginBottom: 2 }}
              // disabled={!table.getIsSomeRowsSelected()}
              onClick={() => setOpenAlertDialog(true)}
              variant="contained"
            >
              Eliminar Rol
            </Button>
          </Grid>
        </Grid>
      </Container>

      <AlertDialog
        open={openAlertDialog}
        accept={yesClick}
        acceptText={"Aceptar"}
        decline={noClick}
        declineText={"Cancelar"}
        title={alertDialog.title}
        text={alertDialog.text}
      />
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { RolEditar };
